module.exports = __webpack_public_path__ + "static/img/diqiu.c6bbb0d9.png";